export const getOpenAIPrompt = (question, systemMessage, whatsAppNumber) => {

    let questionStatement = question.toLowerCase();

    if( (  questionStatement.includes("price") 
        || questionStatement.includes("cost")
        || questionStatement.includes("how much")
        ||  questionStatement.includes("charge")
        )
        && (
            questionStatement.includes("chemical")
            ||  questionStatement.includes("overhaul")
        )
    ){        
        return [
            {"role": "system", "content" : `${systemMessage}`},
            {"role": "user", "content" : "What is the cost of chemical cleaning?"},
            {"role": "assistant", "content" : "Please check price for Chemical wash and Chemical Overhaul here - https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-chemical-wash-and-overhaul. Try the instant quotation to get the exact pricing for your requirements, service date, time and location."},
        ]       
    }
    
    if( (  questionStatement.includes("scope") 
        || questionStatement.includes("include")
        ||  questionStatement.includes("process")
        ||  questionStatement.includes("dismantle blower")
        ||  questionStatement.includes("remove blower")
        ||  questionStatement.includes("remove roller")
        ||  questionStatement.includes("wash roller")
        ||  questionStatement.includes("wash blower")
        ||  questionStatement.includes("clean roller")
        ||  questionStatement.includes("clean blower")
        )
    ){        
        return [
            {"role": "system", "content" : `${systemMessage}`},
            {"role": "user", "content" : "What is the process or job scope of general aircon servicing."},
            {"role": "assistant", "content" : "General aircon servicing is limited to cleaning air filter & front panel, evaporator coil, vacuuming drainage pipe, condenser performance checking, monitor refrigerant gas level. Additional tasks are chargeable, the technician will check the overall performance and inform you if any additional task is needed."},
            {"role": "user", "content" : "Is dismantling of blower for washing included in general service?"},
            {"role": "assistant", "content" : "No, it will cost additional $20/unit to dismantle the blower for washing."},
            {"role": "user", "content" : "What is the process or job scope of Chemical wash."},
            {"role": "assistant", "content" : "Inspection and preparation, disassembly, chemical application, Drainage System Cleaning(additional cost may apply), the technician will apply a specialized cleaning solution to the evaporator and condenser coils, fan blades, and other internal components of the aircon unit. This solution is designed to break down and remove the dirt, dust, and other contaminants that have accumulated over time. Additional tasks are chargeable, the technician will check the overall performance and inform you if any additional task is needed."},
            {"role": "user", "content" : "What is the process or job scope of chemical overhaul"},
            {"role": "assistant", "content" : "Includes everything that is done in Chemical wash and in addition involves dismantling of the entire unit, thorough Cleaning with Chemical, lubrication of fan bearings, reinstallation of the Aircon unit. Visit https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-chemical-wash-and-overhaul for details."}
        ]         
    }

    if( (  questionStatement.includes("repair") 
        || questionStatement.includes("water")
        || questionStatement.includes("leak")
        || questionStatement.includes("noisy")
        || questionStatement.includes("error")
        || questionStatement.includes("switch on")
        || questionStatement.includes("power")
        || questionStatement.includes("turn on")
        || questionStatement.includes("turn off")
        || questionStatement.includes("cold")
        || questionStatement.includes("cool")
        || questionStatement.includes("hot")
        || questionStatement.includes("stopped")
        || questionStatement.includes("not working")
        || questionStatement.includes("blinking")
        || questionStatement.includes("condensation")
        )
    ){        
        return [
            {"role": "system", "content" : `${systemMessage}`},
            {"role": "user", "content" : "Why is my aircon not working, aircon leaking water, noisy condenser, aircon not cold, aircon error codes or got blinking lights."},
            {"role": "assistant", "content" : "You can book for any aircon repair here - https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-repair. Our technician will have to visit your place to troubleshoot and let you know what needs to be serviced/replaced. They will only proceed with the needed service if you approve the cost otherwise you will just pay the visit cost as reflected while booking for repair."},
            {"role": "user", "content" : "What is the cost to fix water leaking from aircon?"},
            {"role": "assistant", "content" : "Submit your request here - https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-leaking-waterand our service team will attend to it as per your selected date and time. The repair cost depends on the problem. We can only give approx. if Chemical Overhaul around: $150, if Drainage flushing is needed: $80 - $120"},
            {"role": "user", "content" : "What is the cost of aircon repair?"},
            {"role": "assistant", "content" : "Actual cost of repair can only be determined after troubleshooting. The initial quote stated during booking for visit and troubleshooting will be offset if you repair with us."},
            {"role": "user", "content" : "When is the earliest service slot?"},
            {"role": "assistant", "content" : `For urgent requests please contact us here - https://wa.me/${whatsAppNumber}`},
        ]
    }
    
    if( ((  questionStatement.includes("price") 
        || questionStatement.includes("cost")
        || questionStatement.includes("how much")
        ||  questionStatement.includes("charge")
        )
        && (
                questionStatement.includes("gas")
            ||  questionStatement.includes("top up")
            ||  questionStatement.includes("refrigerant")
            ||  questionStatement.includes("410A")
            ||  questionStatement.includes("R22")
        )) || (
                questionStatement.includes("gas")
            ||  questionStatement.includes("refill")
        )
    ){        
        return [
            {"role": "system", "content" : `${systemMessage}`},
            {"role": "user", "content" : "How much is gas refill or top-up?"},
            {"role": "assistant", "content" : "Use the instant quotation to check the gas price and to book - https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-gas-top-up"}
        ]
    }

    if( (  questionStatement.includes("How I") 
        || questionStatement.includes("which")
        || questionStatement.includes("how to")
        || questionStatement.includes("how do")
        || questionStatement.includes("type")
        )
        && (
                questionStatement.includes("gas")
            ||  questionStatement.includes("top up")
            ||  questionStatement.includes("refrigerant")
            ||  questionStatement.includes("410A")
            ||  questionStatement.includes("R22")
        )
    ){        
        return [
            {"role": "system", "content" : `${systemMessage}`},
            {"role": "user", "content" : "How do I know which refrigerant gas?"},
            {"role": "assistant", "content" : "If your aircon is within 10 years old, most likely it uses R410A, anything older uses R22."}
        ]
    }

    if( (  questionStatement.includes("price") 
        || questionStatement.includes("cost")
        || questionStatement.includes("how much")
        ||  questionStatement.includes("charge")
        )
        && (
                questionStatement.includes("condenser")
            ||  questionStatement.includes("compressor")
        )
    ){        
        return [
            {"role": "system", "content" : `${systemMessage}`},
            {"role": "user", "content" : "What is the cost of condenser or compressor cleaning?"},
            {"role": "assistant", "content" : "For condenser cleaning pricing visit - https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-condenser-cleaning."}
        ]
    }

    if( (   questionStatement.includes("price") 
        ||  questionStatement.includes("cost")
        ||  questionStatement.includes("how much")
        ||  questionStatement.includes("hidden")
        ||  questionStatement.includes("charge")
        ||  questionStatement.includes("general service")
        ||  questionStatement.includes("general servicing")
        ||  questionStatement.includes("normal service")
        ||  questionStatement.includes("normal cleaning")
        ||  questionStatement.includes("aircon service")
        ||  questionStatement.includes("aircon servicing")
        ||  questionStatement.includes("aircond servicing")
        ||  questionStatement.includes("air con servicing")
        ||  questionStatement.includes("aircon cleaning")
        ||  questionStatement.includes("aircond cleaning")
        ||  questionStatement.includes("air con cleaning")
        ||  questionStatement.includes("discount")
        ||  questionStatement.includes("offers")
        ||  questionStatement.includes("book")
        ||  questionStatement.includes("appointment")
        ) && (   
                !questionStatement.includes("package")
            &&  !questionStatement.includes("contract")
            &&  !questionStatement.includes("annual")
            &&  !questionStatement.includes("quarterly")
            &&  !questionStatement.includes("pcb")
            &&  !questionStatement.includes("trunk")
            &&  !questionStatement.includes("thermistor")
            &&  !questionStatement.includes("control board")
            &&  !questionStatement.includes("mother")
            &&  !questionStatement.includes("blower")
            &&  !questionStatement.includes("roller")
        )
    ){        
        return [
            {"role": "system", "content" : `${systemMessage}`},
            {"role": "user", "content" : "How to book aircon service?"},
            {"role": "assistant", "content" : "Booking is only through the app or website - https://www.stringssg.com/sg/aircon-servicing-singapore."},
            {"role": "user", "content" : "Are there any hidden or extra charges?"},
            {"role": "assistant", "content" : "The pricing is exactly what you see on the app or website, inclusive of all charges."},
            {"role": "user", "content" : "What is the cost of normal aircon servicing?"},
            {"role": "assistant", "content" : "Pricing varies based on your requirement, use the instant quotation for exact pricing for your requirements, service date, time and location - https://www.stringssg.com/sg/aircon-servicing-singapore. For cheapest pricing try booking for a weekday at least 2 days in advance."},
            {"role": "user", "content" : "When is the earliest service slot?"},
            {"role": "assistant", "content" : `For urgent requests please contact us here - https://wa.me/${whatsAppNumber}`},
            {"role": "user", "content" : "Are there any discounts or offers?"},
            {"role": "assistant", "content" : "The pricing generated on the instant quotation is inclusive of great discount - https://www.stringssg.com/sg/aircon-servicing-singapore."},
            {"role": "user", "content" : "Is the price on the website for one-time service or annual package correct?"},
            {"role": "assistant", "content" : "Yes, for general or chemical servicing the price is exactly what you see from the instant quotation on the StringsSG platform or app."}
        ]
    }

    if( (   
            questionStatement.includes("package")
        ||  questionStatement.includes("contract")
        ||  questionStatement.includes("annual")
        ||  questionStatement.includes("quarterly")
        )
    ){        
        return [
            {"role": "system", "content" : `${systemMessage}`},
            {"role": "user", "content" : "What is cost of annual package or one year contract and how to book?"},
            {"role": "assistant", "content" : "For cheapest pricing try booking for a weekday at least 2 days in advance. Try the instant quotation to get exact pricing as per your requirements, service date, time and location. Click - https://www.stringssg.com/sg/aircon-servicing-singapore/annual-package and submit your requirements for annual package."},
            {"role": "user", "content" : "How much is 2 or more years package/contract and how to book?"},
            {"role": "assistant", "content" : "Currently we only offer annual package at a great discount, we recommend trying it. Visit https://www.stringssg.com/sg/aircon-servicing-singapore and select 'More Options'. If you like the service you can always book again with us."},
        ]
    }
    
    if( (  questionStatement.includes("urgent") 
        || questionStatement.includes("earliest")
        || questionStatement.includes("come immediately")
        || questionStatement.includes("today")
        )
    ){        
        return [
            {"role": "system", "content" : `${systemMessage}`},
            {"role": "user", "content" : "When is the earliest service slot?"},
            {"role": "assistant", "content" : `For urgent requests please contact us here - https://wa.me/${whatsAppNumber}`}
        ]
    }

    if( (  questionStatement.includes("cassette") 
        || questionStatement.includes("ceiling aircon")
        )
    ){        
        return [
            {"role": "system", "content" : `${systemMessage}`},
            {"role": "user", "content" : "How much is service for cassette or ceiling aircon"},
            {"role": "assistant", "content" : "Pricing varies based on your requirement, use the instant quotation for exact pricing for your requirements, service date, time and location - https://www.stringssg.com/sg/aircon-servicing-singapore/ceiling-cassette-aircon-service"}
        ]    
    }

    if(!questionStatement || questionStatement?.length < 20
        ){
        return [
                {"role": "system", "content" : `${systemMessage}`},
                {"role": "user", "content" : "How to book aircon service?"},
                {"role": "assistant", "content" : "Booking is only through the app or website - https://www.stringssg.com/sg/aircon-servicing-singapore."},
                {"role": "user", "content" : "Are there any hidden or extra charges?"},
                {"role": "assistant", "content" : "The pricing is exactly what you see on the app or website, inclusive of all charges."},
                {"role": "user", "content" : "What is the cost of normal aircon servicing?"},
                {"role": "assistant", "content" : "Pricing varies based on your requirement, use the instant quotation for exact pricing for your requirements, service date, time and location - https://www.stringssg.com/sg/aircon-servicing-singapore. For cheapest pricing try booking for a weekday at least 2 days in advance."},
                {"role": "user", "content" : "What is the cost of chemical cleaning?"},
                {"role": "assistant", "content" : "Please check price for Chemical wash and Chemical Overhaul here - https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-chemical-wash-and-overhaul. Try the instant quotation to get the exact pricing for your requirements, service date, time and location."},
                {"role": "user", "content" : "Why is my aircon not working, aircon leaking water, noisy condenser, aircon not cold, aircon error codes or got blinking lights."},
                {"role": "assistant", "content" : "You can book for any aircon repair here - https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-repair. Our technician will have to visit your place to troubleshoot and let you know what needs to be serviced/replaced. They will only proceed with the needed service if you approve the cost otherwise you will just pay the visit cost as reflected while booking for repair."},
                {"role": "user", "content" : "What is the cost to fix water leaking from aircon?"},
                {"role": "assistant", "content" : "Submit your request here - https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-leaking-waterand our service team will attend to it as per your selected date and time. The repair cost depends on the problem. We can only give approx. if Chemical Overhaul around: $150, if Drainage flushing is needed: $80 - $120"},
                {"role": "user", "content" : "What is the cost of aircon repair?"},
                {"role": "assistant", "content" : "Actual cost of repair can only be determined after troubleshooting. The initial quote stated during booking for visit and troubleshooting will be offset if you repair with us."},
                {"role": "user", "content" : "When is the earliest service slot?"},
                {"role": "assistant", "content" : `For urgent requests please contact us here - https://wa.me/${whatsAppNumber}`},
                {"role": "user", "content" : "How much is gas refill or top-up?"},
                {"role": "assistant", "content" : "Use the instant quotation to check the gas price and to book - https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-gas-top-up"},
                {"role": "user", "content" : "What is the cost of condenser or compressor cleaning?"},
                {"role": "assistant", "content" : "For condenser cleaning pricing visit - https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-condenser-cleaning."},
                {"role": "user", "content" : "How much is service for cassette or ceiling aircon"},
                {"role": "assistant", "content" : "Pricing varies based on your requirement, use the instant quotation for exact pricing for your requirements, service date, time and location - https://www.stringssg.com/sg/aircon-servicing-singapore/ceiling-cassette-aircon-service"},
                {"role": "user", "content" : "What is cost of annual package or one year contract and how to book?"},
                {"role": "assistant", "content" : "For cheapest pricing try booking for a weekday at least 2 days in advance. Try the instant quotation to get exact pricing as per your requirements, service date, time and location. Click - https://www.stringssg.com/sg/aircon-servicing-singapore/annual-package and submit your requirements for annual package."},
                {"role": "user", "content" : "How much is 2 or more years package/contract and how to book?"},
                {"role": "assistant", "content" : "Currently we only offer annual package at a great discount, we recommend trying it. Visit https://www.stringssg.com/sg/aircon-servicing-singapore and select 'More Options'. If you like the service you can always book again with us."},
                {"role": "user", "content" : "Do you have any discounts or offers?"},
                {"role": "assistant", "content" : "The pricing generated on the instant quotation is inclusive of great discount - https://www.stringssg.com/sg/aircon-servicing-singapore."},
                {"role": "user", "content" : "Is the price on your website for one-time service or annual package correct?"},
                {"role": "assistant", "content" : "Yes, for general or chemical servicing the price is exactly what you see from the instant quotation on the StringsSG platform or app."}
        ]
    }
}